/**
 * Updates the cart item count bubble and aria-label in the header.
 * Listens for cart:updated events to keep the count in sync.
 */
class CartIcon extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('button, a');
    document.addEventListener('cart:updated', (e) => this.update(e.detail));
  }

  get countEl() {
    return this.querySelector('[data-cart-count]');
  }

  update(detail) {
    if (detail?.item_count === undefined) return;

    const count = detail.item_count;
    let badge = this.countEl;

    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.setAttribute('data-cart-count', '');
        badge.setAttribute('aria-hidden', 'true');
        badge.className = 'bag-count';
        this.trigger.appendChild(badge);
      }
      badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }

    if (this.trigger) {
      const label = count === 1 ? 'Korpa, 1 artikal' : `Korpa, ${count} artikala`;
      this.trigger.setAttribute('aria-label', label);
    }
  }
}

customElements.define('cart-icon', CartIcon);

export { CartIcon };
